import { render, staticRenderFns } from "./course-teacher.vue?vue&type=template&id=1dc73ae6&scoped=true"
import script from "./course-teacher.vue?vue&type=script&lang=js"
export * from "./course-teacher.vue?vue&type=script&lang=js"
import style0 from "./course-teacher.vue?vue&type=style&index=0&id=1dc73ae6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc73ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc73ae6')) {
      api.createRecord('1dc73ae6', component.options)
    } else {
      api.reload('1dc73ae6', component.options)
    }
    module.hot.accept("./course-teacher.vue?vue&type=template&id=1dc73ae6&scoped=true", function () {
      api.rerender('1dc73ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/course-teacher.vue"
export default component.exports